import { render, staticRenderFns } from "./UserDataBuyEvents.vue?vue&type=template&id=e28892fe&scoped=true&"
import script from "./UserDataBuyEvents.vue?vue&type=script&lang=js&"
export * from "./UserDataBuyEvents.vue?vue&type=script&lang=js&"
import style0 from "./UserDataBuyEvents.vue?vue&type=style&index=0&id=e28892fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28892fe",
  null
  
)

export default component.exports